<rt-dialog-header [heading]="state.heading!"></rt-dialog-header>

<rt-dialog-body>
  <form [formGroup]="taskForm">
    <div class="item">
      <rt-input
        [maxLength]="255"
        formControlName="title"
        placeholder="Task title"
        variant="rounded"
      >
      </rt-input>
    </div>

    <rt-divider></rt-divider>

    <div class="item status">
      <div class="item-label">
        <rt-label>{{ 'app.tasks.status' | translate }}</rt-label>
      </div>
      <rt-form-field variant="horizontal">
        <rt-checkbox #checkboxComponent formControlName="completed"></rt-checkbox>
        <rt-label [clickable]="true" (click)="checkboxComponent.handleClick($event)">
          {{
            taskForm.controls.completed.value ? statusLabel.completed : statusLabel.not_completed
          }}
          @if (state.task.completed) {
            <span margin-left-small-x> (<rt-date [time]="state.task.completedAt"></rt-date>) </span>
          }
        </rt-label>
      </rt-form-field>
    </div>

    <rt-divider></rt-divider>

    <div class="item candidate">
      <div class="item-label">
        <rt-label>{{ 'app.tasks.candidate' | translate }} </rt-label>
      </div>
      <rt-candidate-select
        [value]="state.candidate!"
        [readOnly]="!state.editableCandidate"
        (valueChange)="changeCandidate($event)"
      >
      </rt-candidate-select>
      @if (state.editableCandidate && state.candidate) {
        <rt-icon-button
          [rtTooltip]="'app.tasks.go_to_candidate' | translate"
          (click)="goToCandidate()"
          variant="plain"
          shape="square"
          iconName="open-in-new"
        >
        </rt-icon-button>
      }
    </div>

    <rt-divider variant="line"></rt-divider>

    <div class="item">
      <div class="item-label">
        <rt-label>{{ 'app.tasks.members' | translate }}</rt-label>
      </div>
      <rt-admins-avatars
        [admins]="state.selectedUsers!"
        [editable]="true"
        [limit]="3"
        (addClick)="editAssignments()"
        (avatarsClick)="editAssignments()"
        variant="rtl"
      >
      </rt-admins-avatars>
    </div>

    <rt-divider variant="line"></rt-divider>

    <div class="item">
      <div class="item-label">
        <rt-label>{{ 'app.tasks.due_date' | translate }}</rt-label>
      </div>
      <rt-button
        (click)="dateDropdown.open = !dateDropdown.open"
        #dateDropdownOrigin="rtOverlayOrigin"
        rt-overlay-origin
        class="due-date"
        variant="plain"
      >
        {{ getTimeDataString() || ('app.tasks.set_due_date' | translate) }}
      </rt-button>
      @if (state.timeData) {
        <rt-icon-button
          (click)="clearTimeData()"
          variant="plain"
          iconName="close"
          shape="square"
          margin-left-small-x
        >
          <rt-icon name="close"></rt-icon>
        </rt-icon-button>
      }
      <ng-template
        #dateDropdown="rtConnectedOverlay"
        rt-connected-overlay
        hasBackdrop
        [origin]="dateDropdownOrigin"
        (backdropClick)="dateDropdown.open = false"
      >
        <rt-dropdown>
          <rt-time-picker [value]="state.timeData" (valueChange)="onTimeChange($event!)">
          </rt-time-picker>
        </rt-dropdown>
      </ng-template>
    </div>

    <rt-divider variant="line"></rt-divider>

    <rt-form-field margin-top>
      <rt-label>{{ 'app.tasks.note' | translate }}</rt-label>
      <rt-textarea
        [placeholder]="'app.tasks.description_placeholder' | translate"
        formControlName="description"
      >
      </rt-textarea>
    </rt-form-field>
  </form>
</rt-dialog-body>

<rt-dialog-footer [hasOptionalActions]="true">
  @if (state.isEditing && !state.loading) {
    <rt-button (click)="delete()" variant="plain" class="optional danger-on-hover">
      <rt-icon name="delete"></rt-icon>
      <span>{{ 'app.common.delete' | translate }}</span>
    </rt-button>
  }
  @if (!state.loading) {
    <rt-button (click)="cancel()" variant="plain" margin-right-small>
      {{ 'app.common.cancel' | translate }}
    </rt-button>
  }
  <rt-button
    [loading]="state.loading"
    [disabled]="taskForm.invalid || taskForm.get('title')!.value.trim() === ''"
    (click)="submit()"
    variant="primary"
  >
    {{ 'app.common.save' | translate }}
  </rt-button>
</rt-dialog-footer>
